import React from "react"

export const TagFilter = ({ tag }) => <div className="tag-filter">{tag}</div>
